export const FIELDS = {
  NAME: 'name',
  FILE: 'file',
  START_DATE: 'start_date',
  END_DATE: 'end_date'
}